import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * tailwind-merge ciente dos tokens do design system: sem isto, `shadow-card`, `rounded-card` ou
 * `text-heading` seriam tratados como cores e não seriam substituídos por `shadow-none`,
 * `rounded-none` ou `text-sm` passados no className.
 */
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: ['display', 'title', 'heading'],
      shadow: ['card', 'raised', 'pop', 'float', 'control', 'btn'],
      radius: ['control', 'card', 'sheet'],
      ease: ['standard', 'snappy', 'spring'],
      animate: ['fade-in', 'slide-up', 'pop', 'scale-in', 'accordion-down', 'accordion-up', 'sheet-up', 'drawer-in', 'shake'],
    },
  },
});

/** Junta classes condicionais resolvendo conflitos do Tailwind (a última vence). */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
